import React from 'react';
import { Box, CircularProgress, Fade, Typography } from '@mui/material';

// ==========================================
// GLOBAL LOADER COMPONENT
// Centralized loading state management
// ==========================================

interface GlobalLoaderProps {
  message?: string;
  size?: number;
  isVisible?: boolean;
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  message = 'Загрузка...',
  size = 40,
  isVisible = false
}) => {
  if (!isVisible) return null;

  return (
    <Fade in={isVisible} timeout={300}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(2px)'
        }}
      >
        <CircularProgress 
          size={size} 
          color="primary"
          sx={{ mb: 2 }}
        />
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

// Smart skeleton component for content loading
export const SmartSkeleton: React.FC<{
  variant?: 'text' | 'rectangular' | 'circular';
  lines?: number;
  height?: number;
}> = ({ variant = 'text', lines = 1, height = 20 }) => (
  <Box sx={{ width: '100%' }}>
    {[...Array(lines)].map((_, i) => (
      <Box
        key={i}
        sx={{
          height,
          bgcolor: 'action.hover',
          borderRadius: variant === 'circular' ? '50%' : 1,
          mb: 1,
          width: variant === 'text' ? '80%' : '100%',
          '&:last-child': { mb: 0 },
          // Shimmer animation
          background: `
            linear-gradient(90deg, 
              transparent, 
              rgba(255,255,255,0.4), 
              transparent
            )
          `,
          backgroundSize: '200% 100%',
          animation: 'shimmer 1.5s infinite',
          '@keyframes shimmer': {
            '0%': { backgroundPosition: '-200% 0' },
            '100%': { backgroundPosition: '200% 0' }
          }
        }}
      />
    ))}
  </Box>
);

export default GlobalLoader; 